import React from 'react'
// eslint-disable-next-line no-restricted-imports -- RN core primitive; NativeWind maps className on it (same pattern as Notification's Animated/Pressable)
import { ScrollView as RNScrollView, type ScrollViewProps as RNScrollViewProps } from 'react-native'

export interface ScrollViewProps extends RNScrollViewProps {
    className?: string
    contentContainerClassName?: string
}

/**
 * Thin universal scroll container — the gluestack/NativeWind replacement for the
 * legacy `aos-ui` `DarkScrollbar` (react-custom-scrollbars). NativeWind maps
 * `className` / `contentContainerClassName` onto the RN core `ScrollView`, which
 * on web (react-native-web) renders a scrollable div. Hide the bar with
 * `showsVerticalScrollIndicator={false}`.
 */
export const ScrollView = React.forwardRef<RNScrollView, ScrollViewProps>(
    function ScrollView(props, ref) {
        return <RNScrollView ref={ref} {...props} />
    },
)

ScrollView.displayName = 'ScrollView'
